import { render } from "./NewLoanCalculatorResult.vue?vue&type=template&id=c6792e56"
import script from "./NewLoanCalculatorResult.vue?vue&type=script&lang=js"
export * from "./NewLoanCalculatorResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__